import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

const SERVICE_NAME = "ServiceEnquiryService.asmx";

@Injectable({
  providedIn: "root",
})
export class ServiceEnquiryService {
  constructor(private http: HttpUtilService) {}

  getVehicleDetails(
    searchOption: string,
    searchText: string,
  ): Observable<any> {
    const encodedOption = encodeURIComponent(
      JSON.stringify(searchOption),
    );
    const encodedText = encodeURIComponent(
      JSON.stringify(searchText),
    );
    return this.http.get(
      `/${SERVICE_NAME}/GetVehicleDetails?searchOption=${encodedOption}&searchText=${encodedText}`,
    );
  }

  updateServiceEnquiry(payload: any): Observable<any> {
    return this.http.post(`/${SERVICE_NAME}/Update`, payload);
  }
}
